import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

import { State } from '®app/ngrx/state';
import { ModalControlsSaveable } from '®shared/modals';
import { UserPermissions } from '®shared/permissions';
import { EditableList } from '®shared/reading-list/models';
import { License, Period } from '®shared/tenant';

import {
  ListDetailsEditorHideModalAction,
  ListDetailsEditorSaveAction,
} from './list-details-editor.actions';
import { selectListDetailsEditorState } from './list-details-editor.state';

@Component({
  selector: 'rl-list-details-editor-modal',
  templateUrl: './list-details-editor-modal.component.html',
})
export class ListDetailsEditorModalComponent implements OnDestroy, OnInit {
  @Input() editableList: EditableList;
  @Input() currentUserPermissions: UserPermissions;
  @Input() licenses: License[];
  @Input() timePeriods: Period[];

  @ViewChild('listDetailsEditorModal', { static: true })
  public listDetailsEditorModal: ModalDirective;

  private stateSubscription: Subscription;

  modalControl: ModalControlsSaveable;

  constructor(private cd: ChangeDetectorRef, private store: Store<State>) {}

  ngOnInit() {
    this.stateSubscription = this.store
      .select(selectListDetailsEditorState)
      .subscribe(state => {
        this.modalControl = state.modalControl;

        const { isShown } = state.modalControl;
        if (isShown && !this.listDetailsEditorModal.isShown) {
          this.listDetailsEditorModal.show();
        } else if (!isShown && this.listDetailsEditorModal.isShown) {
          this.listDetailsEditorModal.hide();
        }

        this.cd.markForCheck();
      });
  }

  ngOnDestroy() {
    if (this.stateSubscription) {
      this.stateSubscription.unsubscribe();
    }
  }

  onSave(action: ListDetailsEditorSaveAction) {
    this.store.dispatch(action);
  }

  onClose() {
    this.store.dispatch(new ListDetailsEditorHideModalAction());
  }
}
